import React, {Component} from 'react'
import {renderComponent} from './Layout'

class Section extends Component {
    constructor(props) {
        super(props)
        this.onScroll = this.onScroll.bind(this)
        this.onResize = this.onResize.bind(this)
        this.state = { onScreen: false }
        this.sectionElement = null;
    }

    onScroll() {
        this.checkPosition()
    }

    onResize() {
        this.checkPosition()
    }

    removeScrollHandler() {
        window.removeEventListener('scroll', this.onScroll, false);
        window.removeEventListener('resize', this.onResize, false);
    }

    isElementInViewport (el) {
        var rect = el.getBoundingClientRect();

        return (
            rect.top >= 0 &&
            rect.top <= (window.innerHeight || document.documentElement.clientHeight)- 50
        );
    }

    checkPosition() {
        if (!this.sectionElement) return null;
        if (this.state.onScroll) return null;
        if (this.isElementInViewport(this.sectionElement)) {
            this.removeScrollHandler()
            this.setState({onScreen:true})
        }
    }

    componentDidMount() {
        window.addEventListener('scroll', this.onScroll, false);
        window.addEventListener('resize', this.onResize, false);
        this.checkPosition()
    }

    componentWillUnmount() {
        this.removeScrollHandler()
    }

    render() {
        const props = this.props;
        const settings = props.settings || {}
        let children = props.children || {}

        const classNames = ['section']
        if (settings.class) {
            classNames.push(settings.class)
        } else {
            classNames.push('white-section')
        }

        if (this.state.onScreen) {
            classNames.push('on-screen')
        }

        return (
            <section ref={element => this.sectionElement = element} className={classNames.join(' ')}>
                <div className="section-content">
                    <div className="container">
                    {children.map((c,i) => renderComponent(c,i))}
                    </div>
                </div>
            </section>  
        )
    }
}

export default Section


// WEBPACK FOOTER //
// ./src/components/Section.js